import React, {useState} from 'react';
import styled from 'styled-components'
import {truncateString} from "../../../helper/truncate";


function Card({name, description, university, career, module, block, duration, isFree, url}) {
    return (
        <Wrapper onClick={() => {
            if(trackEvent) trackEvent('click_on_landing_search_course')
            location.href = url;
        }}>
            <WrapperImage><img src='/images/icons/video_icon.svg' /> </WrapperImage>
            <Header>{university} > {career}</Header>
            <NameContainer>{name}</NameContainer>
            <Header2>{module} > {block}</Header2>
            <DescriptionContainer>{description ? truncateString(description.replace(/<[^>]*>?/gm, ''), 120) : null}</DescriptionContainer>
        </Wrapper>
    );
}


const Wrapper = styled.div`
    width: 220px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: 1px solid #5F676D;
    margin: 4px;
    border-radius: 8px;
    &:hover {
        border-color: white;
    }
    @media only screen and (max-width: 600px) {
         width: 100%;
    }
`

const WrapperImage = styled.div`
`

const Header = styled.div`
    font-size: 14px;
    margin-top: 12px;
    color: white;
`
const Header2 = styled.div`
    font-size: 12px;
    margin-top: 4px;
`

const NameContainer = styled.div`
    color: #FA9F63;
    margin-top: 12px;
`

const DescriptionContainer = styled.div`
    color: white;
    margin-top: 16px;
    font-size: 14px;
`

export default Card;
